import { useMultiImageUploader } from '@/customHooks/useMultiImageUploader'
import { Button } from '../atoms'
import { useEffect } from 'react'
import { useUserLanguage } from '@/customHooks'
import textsData from '@/textData/ImageUploaderTexts.json'

type ImageUploaderProps = {
  onUploadReady?: (files: File[]) => void
}

export const ImageUploader = ({ onUploadReady }: ImageUploaderProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const {
    handleFileChange,
    previews,
    compressedFiles,
    isCompressing,
    error,
    reset,
    removeImage,
  } = useMultiImageUploader({
    quality: 0.8,
    maxSizeMB: 0.8,
    maxWidthOrHeight: 1280,
    maxFiles: 10,
    onCompressError: (err) => {
      console.error(`${texts.compressError}`, err.message)
    },
    onCompressSuccess: (files) => {
      console.log(`${texts.compressSuccess}`, files)
    },
  })

  useEffect(() => {
    // Notifica al componente padre cada vez que la lista de archivos cambie.
    onUploadReady?.(compressedFiles)
  }, [compressedFiles])

  return (
    <div style={{ padding: '20px', border: '2px dashed #ccc', borderRadius: '8px' }}>
      <h3>📷 Subir y comprimir imágenes (a WebP)</h3>

      {compressedFiles.length < 10 && (
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          disabled={isCompressing}
          multiple
        />
      )}

      {compressedFiles.length > 0 && (
        <p>
          {compressedFiles.length} de 10 imágenes cargadas.
        </p>
      )}

      {isCompressing && <p>{texts.compressingImages}</p>}

      {error && (
        <div style={{ color: 'red', marginTop: '10px' }}>
          ❌ {error}
        </div>
      )}

      {previews.length > 0 && (
        <>
          <div style={{ marginTop: '20px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            <h4>Vistas previas:</h4>
            {previews.map((preview, index) => {
              const file = compressedFiles[index]
              return (
                <div key={index} style={{ border: '1px solid #ddd', borderRadius: '4px', padding: '10px', maxWidth: '200px' }}>
                  <img
                    src={preview.url}
                    alt={`Preview ${index}`}
                    style={{
                      maxWidth: '100%',
                      maxHeight: '150px',
                      borderRadius: '4px',
                    }}
                  />
                  <div style={{ marginTop: '10px', fontSize: '12px' }}>
                    <p style={{ margin: 0, wordBreak: 'break-all' }}>
                      <strong>{texts.fileNameLabel}</strong> {file?.name}
                    </p>
                    <p style={{ margin: '5px 0' }}>
                      <strong>{texts.fileSizeLabel}</strong>{' '}
                      {file
                        ? (file.size / 1024).toFixed(2) + ' KB'
                        : 'N/A'}
                    </p>
                    <Button onClick={() => removeImage(index)} secondary>
                      {texts.deleteButton}
                    </Button>
                  </div>
                </div>
              )
            })}
          </div>
          {compressedFiles.length > 0 && (
            <Button onClick={reset} secondary>
              Limpiar todo
            </Button>
          )}
        </>
      )}
    </div>
  )
}